export class DateInterval {
  startDate: Date | number | any;
  endDate: Date | number | any;

  constructor() {}
}
